__turbopack_context__.v({
  "blinkTwice": "blog-module-scss-module__6Xrk8q__blinkTwice",
  "blogCard": "blog-module-scss-module__6Xrk8q__blogCard",
  "blogCardWrapper": "blog-module-scss-module__6Xrk8q__blogCardWrapper",
  "blogDetail": "blog-module-scss-module__6Xrk8q__blogDetail",
  "blogHero": "blog-module-scss-module__6Xrk8q__blogHero",
  "blogIcon": "blog-module-scss-module__6Xrk8q__blogIcon",
  "blogIndex": "blog-module-scss-module__6Xrk8q__blogIndex",
  "breadcrumb": "blog-module-scss-module__6Xrk8q__breadcrumb",
  "breadcrumbCurrent": "blog-module-scss-module__6Xrk8q__breadcrumbCurrent",
  "breadcrumbLink": "blog-module-scss-module__6Xrk8q__breadcrumbLink",
  "cardBottom": "blog-module-scss-module__6Xrk8q__cardBottom",
  "cardExcerpt": "blog-module-scss-module__6Xrk8q__cardExcerpt",
  "cardIcon": "blog-module-scss-module__6Xrk8q__cardIcon",
  "cardImage": "blog-module-scss-module__6Xrk8q__cardImage",
  "cardImageFallback": "blog-module-scss-module__6Xrk8q__cardImageFallback",
  "cardMedia": "blog-module-scss-module__6Xrk8q__cardMedia",
  "cardTitle": "blog-module-scss-module__6Xrk8q__cardTitle",
  "collapseWindow": "blog-module-scss-module__6Xrk8q__collapseWindow",
  "detailHeading2": "blog-module-scss-module__6Xrk8q__detailHeading2",
  "detailHeading3": "blog-module-scss-module__6Xrk8q__detailHeading3",
  "detailImage": "blog-module-scss-module__6Xrk8q__detailImage",
  "detailNav": "blog-module-scss-module__6Xrk8q__detailNav",
  "detailPanel": "blog-module-scss-module__6Xrk8q__detailPanel",
  "detailParagraph": "blog-module-scss-module__6Xrk8q__detailParagraph",
  "detailScroller": "blog-module-scss-module__6Xrk8q__detailScroller",
  "detailStage": "blog-module-scss-module__6Xrk8q__detailStage",
  "detailTitle": "blog-module-scss-module__6Xrk8q__detailTitle",
  "expandFromTopLeft": "blog-module-scss-module__6Xrk8q__expandFromTopLeft",
  "expandWindow": "blog-module-scss-module__6Xrk8q__expandWindow",
  "heroIntro": "blog-module-scss-module__6Xrk8q__heroIntro",
  "heroRow": "blog-module-scss-module__6Xrk8q__heroRow",
  "pageTitle": "blog-module-scss-module__6Xrk8q__pageTitle",
  "panelGroup": "blog-module-scss-module__6Xrk8q__panelGroup",
  "readMoreButton": "blog-module-scss-module__6Xrk8q__readMoreButton",
  "scrollThumb": "blog-module-scss-module__6Xrk8q__scrollThumb",
  "scrollTrack": "blog-module-scss-module__6Xrk8q__scrollTrack",
  "scrollerFrame": "blog-module-scss-module__6Xrk8q__scrollerFrame",
  "scrollerInset": "blog-module-scss-module__6Xrk8q__scrollerInset",
  "shrinkToTopLeft": "blog-module-scss-module__6Xrk8q__shrinkToTopLeft",
});
